export default __webpack_public_path__ + "static/media/bg-sign-in-basic.f327db1d.jpeg";